import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
// Clean, minimal card for business applications
const BasicCard = React.forwardRef(({ className, children, ...props }, ref) => {
    return (_jsx("div", { ref: ref, className: cn('bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm', className), ...props, children: children }));
});
BasicCard.displayName = 'BasicCard';
const BasicCardHeader = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('px-6 py-4 border-b border-gray-200 dark:border-gray-700', className), ...props })));
BasicCardHeader.displayName = 'BasicCardHeader';
const BasicCardTitle = React.forwardRef(({ className, ...props }, ref) => (_jsx("h3", { ref: ref, className: cn('text-lg font-semibold text-gray-900 dark:text-gray-100', className), ...props })));
BasicCardTitle.displayName = 'BasicCardTitle';
const BasicCardContent = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('px-6 py-4', className), ...props })));
BasicCardContent.displayName = 'BasicCardContent';
export { BasicCard, BasicCardHeader, BasicCardTitle, BasicCardContent };
